module.exports = __webpack_public_path__ + "img/harmonize.f1e3590f.png";